import { render, staticRenderFns } from "./MeditationRingtuneEditModal.vue?vue&type=template&id=36d0b74c"
import script from "./MeditationRingtuneEditModal.vue?vue&type=script&lang=js"
export * from "./MeditationRingtuneEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports